import { ColumnDef } from "@tanstack/react-table";
import { Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TFunction } from "i18next";
import { ImporterDto } from "@/types/api/api-types";

export const getImporterColumns = (
  t: TFunction<"boCatalog">,
  onEdit: (importer: ImporterDto) => void,
  onDelete: (importer: ImporterDto) => void,
  canManageImporters: boolean,
): ColumnDef<ImporterDto>[] => [
  {
    accessorKey: "name",
    header: t("importersTable.columns.name"),
    cell: (info) => (
      <span className="text-base font-medium text-gray-900">{info.row.original.name}</span>
    ),
  },
  {
    accessorKey: "email",
    header: t("importersTable.columns.email"),
    enableSorting: false,
    cell: (info) => <span className="text-sm text-gray-600">{info.row.original.email}</span>,
  },
  {
    accessorKey: "phone",
    header: t("importersTable.columns.phone"),
    enableSorting: false,
    cell: (info) => <span className="text-sm text-gray-600">{info.row.original.phone}</span>,
  },
  {
    accessorKey: "address",
    header: t("importersTable.columns.address"),
    enableSorting: false,
    cell: (info) => <span className="text-sm text-gray-600">{info.row.original.address}</span>,
  },
  {
    accessorKey: "city",
    header: t("importersTable.columns.city"),
    enableSorting: false,
    cell: (info) => <span className="text-sm text-gray-600">{info.row.original.city}</span>,
  },
  {
    accessorKey: "state",
    header: t("importersTable.columns.state"),
    enableSorting: false,
    cell: (info) => <span className="text-sm text-gray-600">{info.row.original.state}</span>,
  },
  {
    accessorKey: "zip",
    header: t("importersTable.columns.zip"),
    enableSorting: false,
    cell: (info) => <span className="text-sm text-gray-600">{info.row.original.zip}</span>,
  },
  {
    accessorKey: "country",
    header: t("importersTable.columns.country"),
    enableSorting: false,
    cell: (info) => <span className="text-sm text-gray-600">{info.row.original.country}</span>,
  },
  {
    id: "actions",
    header: "",
    enableSorting: false,
    cell: (info) => (
      <div className="flex flex-row gap-1">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onEdit(info.row.original)}
          disabled={!canManageImporters}
        >
          <Pencil className="h-4 w-4 text-gray-500" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onDelete(info.row.original)}
          disabled={!canManageImporters}
        >
          <Trash2 className="h-4 w-4 text-red-500" />
        </Button>
      </div>
    ),
  },
];
